 <div class="table-responsive table-scroll-small">
      <table class="table table-bordered table-sm table-striped">
        <thead>
        <tr>
          <th scope="col" (click)="setOrder('timestamp')">{{ 'colTimestamp' | translate }}
           <i class="fa" [ngClass]="getClass('timestamp')"></i>
          </th>
          <th scope="col" (click)="setOrder('sixLetterCode')">{{ 'colInstrument' | translate }}
            <i class="fa" [ngClass]="getClass('sixLetterCode')"></i>
          </th>

          <th scope="col" (click)="setOrder('swap')">{{ 'colSwap' | translate }}
            <i class="fa" [ngClass]="getClass('swap')"></i>
          </th>

          <th scope="col" (click)="setOrder('validity')">{{ 'colValidity' | translate }}
            <i class="fa" [ngClass]="getClass('validity')"></i>
          </th>

          <th scope="col" (click)="setOrder('quantity')">{{ 'colQty' | translate }}
            <i class="fa" [ngClass]="getClass('quantity')"></i>
          </th>

          <th scope="col" (click)="setOrder('profit')">{{ 'colBorrowPrice' | translate }}
            <i class="fa" [ngClass]="getClass('profit')"></i>
          </th>

          <th scope="col" (click)="setOrder('profit')">{{ 'colLendPrice' | translate }}
            <i class="fa" [ngClass]="getClass('profit')"></i>
          </th>

          <th scope="col" (click)="setOrder('quantity')">{{ 'colQty' | translate }}
            <i class="fa" [ngClass]="getClass('quantity')"></i>
          </th>

          <th scope="col" (click)="setOrder('counterPartyId')">{{ 'colCounterPartyId' | translate }}
            <i class="fa" [ngClass]="getClass('counterPartyId')"></i>
          </th>

          <th scope="col" class="cancel"></th>
          <th scope="col" class="cancel"></th>
        </tr>
        </thead>
        <tbody *ngIf="!OrderbookColumns.length">
      <tr *ngFor="let i of Arr(num).fill(1)"><td>&nbsp;</td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td></tr>
      </tbody>

        <tbody *ngIf="OrderbookColumns.length">
          <ng-container *ngFor="let column of OrderbookColumns | multiOrder: order, let i = index">
          <tr *ngIf="OrderbookColumns.length" id="{{'ORDER_BOOK_ROW_' + i}}">

            <td class="text-center" *ngIf="(column.timestamp | date:'yyyy') === (today | date: 'yyyy')">
              {{column.timestamp | date:'dd MMM - HH:mm:ss'}}
            </td>

            <td class="text-center" *ngIf="(column.timestamp | date:'yyyy') !== (today | date: 'yyyy')">
              {{column.timestamp | date:'dd MMM yyyy - HH:mm:ss'}}
            </td>

            <td class="text-center">{{currencyPairs[column.sixLetterCode].instrument.name}}</td>
            <td class="text-center">{{column.swap}}</td>
            <td class="text-center">{{column.validity ? column.validity : 'GTC'}}</td>
            <td class="text-right"><span *ngIf="column.direction === 'BORROW'">{{column.quantity | number:'1.2-2'}}</span></td>
            <td class="text-right"><span *ngIf="column.direction === 'BORROW'">{{column.sixLetterCode.includes('JPY') ? (column.profit | priceFactorPipe: column.sixLetterCode | number:'1.0') : (column.profit | priceFactorPipe: column.sixLetterCode | number:'1.2-2')}}</span></td>
            <td class="text-right"><span *ngIf="column.direction === 'LEND'">{{column.sixLetterCode.includes('JPY') ? (column.profit | priceFactorPipe: column.sixLetterCode | number:'1.0') : (column.profit | priceFactorPipe: column.sixLetterCode | number:'1.2-2')}}</span></td>
            <td class="text-right"><span *ngIf="column.direction === 'LEND'">{{column.quantity | number:'1.2-2'}}</span></td>
            <td class="text-right" style="padding-right: 10px;">{{users[column.counterPartyId]?.username}}</td>
            <td class="text-center text-success" (click)="openModifyOrderModal(column)"><span *ngIf="column.ocoLinkId">o</span><i class="fa fa-edit fa-lg"></i><span *ngIf="column.ocoLinkId">o</span></td>
            <td class="text-center text-danger" (click)="openCancelModal(column)"><span *ngIf="column.ocoLinkId">o</span><i class="fa fa-times fa-lg"></i><span *ngIf="column.ocoLinkId">o</span></td>
        </tr>
          </ng-container>
        </tbody>
      </table>
    </div><!-- responsive table END -->
 <div class="form-group d-flex justify-content-between align-items-center">

<!--   <button class="btn btn-sm btn-primary mr-4">-->
<!--     <input type="file" class="file-input" accept=".csv"-->
<!--            (change)="onFileSelected($event)" #fileUpload>-->
<!--     <i class="fa fa-upload" aria-hidden="true"></i> {{ 'buttonUpload' | translate }}-->
<!--   </button>-->
<!--   <div>-->
<!--     <input type="file" class="file-input" accept=".csv"-->
<!--            (change)="onFileSelected($event)" #fileUpload>-->
<!--&lt;!&ndash;     <i class="fa fa-upload" aria-hidden="true"></i> {{ 'buttonUpload' | translate }}&ndash;&gt;-->
<!--   </div>-->

   <div *ngIf="!isSuperUser">
     <input type="file" #fileImportInput name="File Upload" id="csvFileUpload" (change)="fileChangeListener($event)" accept=".csv"/>
     <span *ngIf="csvError">
       {{csvError}}
     </span>
     <button class="btn btn-outline-secondary" (click)="submitUploadFile()" [disabled]="!csvRecords">
       Submit
     </button>
   </div>

<!--   <div class="ms-3">-->
<!--     <input type="file" class="file-input" accept=".csv"-->
<!--            (change)="onFileSelected($event)" #fileUpload>-->

<!--     <div class="file-upload">-->

<!--       {{fileName || "Select file"}}-->

<!--       <button class="btn btn-outline-primary"-->
<!--               (click)="fileUpload.click()">-->
<!--         <i class="fa fa-lg fa-upload"></i>-->
<!--       </button>-->
<!--       <button class="btn btn-primary ms-3" [disabled]="!selectedFile" (click)="submitUploadFile()">-->
<!--         Submit-->
<!--       </button>-->
<!--     </div>-->
<!--   </div>-->
<!--   <button class="btn btn-sm btn-primary mr-4">-->
<!--     <i class="fa fa-upload" aria-hidden="true"></i> {{ 'buttonUpload' | translate }}-->
<!--   </button>-->

   <button id="cancelAllOrderBtn" class="btn btn-sm btn-primary" (click)="cancelAllOrders()" *ngIf="this.OrderbookColumns.length > 0">
     <i class="fa fa-times" aria-hidden="true"></i> {{ 'buttonCancelOrders' | translate }}
   </button>
 </div>
